module.exports = __webpack_public_path__ + "static/media/chat-help.66452ee9.svg";